import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import type { FC, PropsWithChildren } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'

import type { Startups } from 'views/Industry/StartupsPage/data'

import LayoutBase from '@segment/next-shared/layout'

import Testimonial from './components/Testimonial'
import Hero from './components/Hero'

import OneApiImage from './components/OneApi'
import LetEngineersFocused from './components/LetEngineersFocused'
import SegmentCredits from './components/SegmentCredits'
import WantDoubleSegmentCredits from './components/WantDoubleSegmentCredits'
import ThousandsTrustSegment from './components/ThousandsTrustSegment'
import SignUp from './components/SignUp'

import LearnHowAnalytics from './components/LearnHowAnalytics'
import AnalyticsForStartups from './components/AnalyticsForStartups'
import GetExclusiveDeals from './components/GetExclusiveDeals'

import ogImagePng from './assets/OgIndustryStartups.png'

export interface StartupsProps {
  data: Startups
}
const IndustryStartupsView: FC<PropsWithChildren<StartupsProps>> = ({ data }) => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="Twilio Segment Startup Program | Twilio Segment "
        pageDescription="Twilio Segment is an API-first analytics solution that empowers 20k+ startups to scale their data infrastructure. Collect, clean & act on your customer data."
        pageOG={ogImagePng}
        themeColor={theme.palette.brand.darkAcai[700]}
      >
        <NavigationV2 />
        <Hero />
        <Main>
          <Testimonial />
          <LetEngineersFocused />
          <OneApiImage />
          <SegmentCredits />
          <WantDoubleSegmentCredits />
          <ThousandsTrustSegment />
          <LearnHowAnalytics cards={data.cards} />
          <AnalyticsForStartups />
          <GetExclusiveDeals deals={data.deals} />
          <SignUp />
        </Main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default IndustryStartupsView
